import { SOUND_EVENT_TYPE } from './constant.js';
import { soundEventElementToHtml } from './element-to-html.js';
import { soundEventHtmlToElement } from './html-to-element.js';
import { soundEventPlugin } from './plugin.js';
import { soundEventRenderElement } from './render-element.js';
import { soundEventSerializer } from './serializer.js';

const SoundEventModule = {
  type: SOUND_EVENT_TYPE,
  renderElement: soundEventRenderElement,
  elementToHtml: soundEventElementToHtml,
  htmlToElement: soundEventHtmlToElement,
  plugin: soundEventPlugin,
  serializer: soundEventSerializer
};

export { SoundEventModule };
//# sourceMappingURL=module.js.map
